// pages/Quiz1.tsx
import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    AppBar, Toolbar, Avatar, Typography, IconButton, Switch, CircularProgress, Pagination, Modal, TextField
} from '@mui/material';
import {useNavigate, useParams, useSearchParams} from "react-router-dom";

import api, {addQuiz, deleteQuiz, getQuizzes} from '../services/api';
import { Add } from '@mui/icons-material';

import {QuizModel} from "../services/types";
import Icon from "../components/Icon";

const Quiz4: React.FC = () => {
    const [quizzes, setQuizzes] = useState<QuizModel[]>([]);
    const [loading, setLoading] = useState(true);
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [createName, setCreateName] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [page, setPage] = useState(1);
    const [searchParams, setSearchParams] = useSearchParams();
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [deleteQuizId, setDeleteQuizId] = useState('');

    const [totalQuizzes, setTotalQuizzes] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        loadQuizzes();
    }, [page]);

    const loadQuizzes = async () => {
        setLoading(true)
        try {
            const response = await getQuizzes({
                page: page,
                limit: 20,
                quiz_type: 3,
                sort_by: 'created_at',
                sort_order: 'asc',
            });
            setQuizzes(response.items);
            setTotalQuizzes(response.total)
            setTotalPages(response.total_pages)
            setPage(response.page)
            setLoading(false)
        } catch (error) {
            console.error('Error fetching quizzes:', error);
        }
    };

    const handleQuizClick = (quizId: string) => {
        // console.log(quizId)
        navigate(`/quiz4/${quizId}`);
    };

    const handlePageChange = (event: React.ChangeEvent<unknown>, newPage: number) => {
        setPage(newPage);
        setSearchParams({ page: newPage.toString() });
    };

    const handleCreate = async () => {
        try {
            const addData = {
                title: createName,
                type: 3
            }
            await addQuiz(addData);
            setIsCreateModalOpen(false);
            setCreateName('');
            loadQuizzes();
        } catch (error) {
            console.error('Error inviting team member:', error);
            setError('Failed to send invitation');
        }
    };

    const openDeleteModal = (id: string) => {
        setDeleteQuizId(id);
        setIsDeleteModalOpen(true);
    };

    const handleDeleteQuiz = async () => {
        try {
            await deleteQuiz(deleteQuizId);
            loadQuizzes();
            setIsDeleteModalOpen(false);
        } catch (error) {
            console.error('Error deleting source:', error);
        }
    };

    return (
        <Box>
            <AppBar position="static">
                <Toolbar className='toolbar'>
                    <Box className='toolbarTitle'>
                        <Box>Рак головы и шеи <span>{totalQuizzes}</span></Box>
                    </Box>
                    <Button className="addToobarBtn" variant="contained" onClick={() => {}}><Add /></Button>
                </Toolbar>
            </AppBar>

            <Box>
                <Box className='topButtonsContainer hideMPageButtons'>
                    <Box></Box>
                    <Button className='topButtonsAdd' variant="outlined" onClick={() => setIsCreateModalOpen(true)}><Add /> Добавить квиз</Button>
                </Box>
                {!loading && (

                    <Box className='scenarioList'>
                        {quizzes.map((item) => (
                            <Box className={item.is_active ? 'scenarioItem active' : 'scenarioItem'} key={item.id} sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
                                <Box sx={{ flexGrow: 1 }} className='scenarioItemTitle'>{item.title}</Box>
                                <Box sx={{position:'absolute', left: 0, top: 0, width: '100%', height: '100%'}} onClick={() => handleQuizClick(item.id)}></Box>
                                <IconButton onClick={() => openDeleteModal(item.id)}><Icon name="remove" /></IconButton>
                            </Box>
                        ))}
                    </Box>
                )}
            </Box>

            {loading && (
                <Box className='notFoundElements'>
                    <CircularProgress/>
                </Box>
            )}
            {(totalQuizzes === 0 && !loading) && (
                <Box className='notFoundElements'>
                    <Typography>Квизы не найдены</Typography>
                </Box>
            )}

            {(totalPages > 1 && !loading) && (
                <Pagination className='paginationElement' count={totalPages} page={page} onChange={handlePageChange} />
            )}

            {/* Модальное окно добавления */}
            <Modal open={isCreateModalOpen} onClose={() => setIsCreateModalOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 600 }}>
                        <Typography variant="h6">Создание квиза</Typography>
                        <TextField
                            label="Название"
                            value={createName}
                            onChange={(e) => setCreateName(e.target.value)}
                            fullWidth
                            type="email"
                            margin="normal"
                        />
                        <Box sx={{display:'flex', justifyContent: 'space-between', mt: 2, gap: 2}}>
                            <Button className="blueModalButton" variant="contained" onClick={handleCreate}>
                                Создать
                            </Button>
                            <Button className="blueModalButton" variant="outlined" onClick={()=>setIsCreateModalOpen(false)} style={{color: 'red', borderColor: 'red'}}>
                                Отмена
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>


            {/* Модальное окно подтверждения удаления */}
            <Modal open={isDeleteModalOpen} onClose={() => setIsDeleteModalOpen(false)}>
                <Box sx={{minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box sx={{ p: 4, bgcolor: 'white', margin: 'auto', width: 400,borderRadius: 2 }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            Вы действительно хотите удалить этот квиз?
                        </Typography>
                        <Button variant="contained" color="secondary" onClick={handleDeleteQuiz}>
                            Удалить
                        </Button>
                        <Button onClick={() => setIsDeleteModalOpen(false)} sx={{ ml: 2 }}>
                            Отмена
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </Box>


    );
};

export default Quiz4;
